// extracted by mini-css-extract-plugin
module.exports = {"button":"popup_button__jml_u","personalInfo":"popup_personalInfo__XQETF","personalInfoLink":"popup_personalInfoLink__JRqPa"};